import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import { useSnackbar } from 'notistack';
import Iconify from 'src/components/Iconify';
import { pagesText } from 'src/constants/pagesText';
import { useDownloadArtifact } from 'src/hooks/environmentWdacPolicy';
import { handleFileDownload } from 'src/utils/download.util';

// Downloads the file behind one artifact. It sits in clickable rows, which should not also open on
// a download.
const ArtifactDownloadButton = ({ artifact }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { mutateAsync: downloadArtifact, isLoading } = useDownloadArtifact();

  const download = async event => {
    event.stopPropagation();
    try {
      const blob = await downloadArtifact(artifact.id);
      handleFileDownload(blob, artifact.fileName || `artifact_${artifact.id}`);
    } catch {
      enqueueSnackbar(pagesText.somethingWentWrong, { variant: 'error', autoHideDuration: 3000 });
    }
  };

  return (
    <Tooltip title="Download">
      <span>
        <IconButton
          size="small"
          disabled={isLoading}
          onClick={download}
          sx={{ p: 0.25, color: '#9CA3AF' }}>
          <Iconify icon="mdi:download-outline" width={16} height={16} />
        </IconButton>
      </span>
    </Tooltip>
  );
};

ArtifactDownloadButton.propTypes = {
  artifact: PropTypes.shape({
    id: PropTypes.number.isRequired,
    fileName: PropTypes.string,
  }).isRequired,
};

export default ArtifactDownloadButton;
